<template>
    <div class="upload-file" :class="{ 'upload-file--zone': zone }" @file-change="handleFileChange">
        <template v-if="zone">
            <ul v-if="fileList.length" class="file-list file-list--zone">
                <li class="csp" v-for="(item, index) in fileList" :key="index">
                    <span class="name" @click="openFile(item)">{{ item.name }}</span>
                    <button type="button" class="delete" :disabled="isDisable" @click.prevent="deleteFile(index)">✕</button>
                </li>
            </ul>
            <div class="upload-zone-trigger" :class="{ 'is-disabled': isDisable, 'drag-over': zoneDragOver }"
                @click="onZoneClick" @dragover.prevent="onZoneDragOver" @dragenter.prevent="onZoneDragOver"
                @dragleave.prevent="onZoneDragLeave" @drop.prevent="onZoneDrop">
                {{ text }}
            </div>
        </template>
        <template v-else>
        <!-- 上传按钮 -->
        <el-col :span="8">
            <el-button class="upload" icon="el-icon-plus" @click="openDrawer(true)" :disabled="isDisable">
                {{ text }}
            </el-button>
        </el-col>
        <!-- 提示和视频网址 -->
        <el-col :span="10">
            <div class="tips">
                <img src="@/assets/images/addclass/tishi.png" alt v-if="tips.image" />
                <div v-if="tips.url">
                    <p class="text">或粘贴视频网址：</p>
                    <el-input style="width:242px" show-word-limit v-model="link" @change="changeLink">
                    </el-input>
                </div>
            </div>
        </el-col>
        <!-- 展示列表 -->
        <ul class="file-list">
            <li class="csp" v-for="(item, index) in fileList" :key="index">
                <span class="name" @click="openFile(item)">{{ item.name }}</span>
                <button class="delete el-icon-close csp" :disabled="isDisable" @click.prevent="deleteFile(index)"></button>
            </li>
        </ul>
        </template>
        <!-- 本地断点续传 -->
        <el-drawer v-if="!BreakPointUpload" title="" :visible.sync="isOpenDrawer" @opened="onDrawerOpened"
            :before-close="handleClose">
            <upimg ref="upimg" v-if="isOpenDrawer" :upimgload="true" @closeMain="closeMain"></upimg>
        </el-drawer>

        <!-- 右侧上传栏 -->
        <el-drawer v-if="BreakPointUpload" title="" :visible.sync="isOpenDrawer" :before-close="handleClose"
            :append-to-body="true" @opened="onDrawerOpened">
            <ossUploader ref="upload" v-if="isOpenDrawer" @closeMain="closeMain" :AdjustTheType="AdjustTheType" :accept="accept"></ossUploader>
        </el-drawer>
    </div>
</template>

<script>
export default {
    props: {
        // 名称
        name: {
            required: true,
            type: String
        },
        text: {
            type: String,
            default: '上传文件'
        },
        list: {
            type: Array,
            default: () => []
        },
        // 是否显示提示框和视频网址input
        tips: {
            type: Object,
            default: () => {
                return {
                    image: false,
                    url: false,
                }
            }
        },
        xlink: {
            type: String
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        AdjustTheType: {
            type: String,
            default: ''
        },
        /** 整行虚线上传区（行前准备等页面原型样式） */
        zone: {
            type: Boolean,
            default: false,
        },
        /** 限制可选文件类型，透传给 ossUploader，格式同 input accept */
        accept: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            isDisable: false,
            // upimgload: false,
            isOpenDrawer: false, // 侧边栏是否呈开启状态
            fileList: [], //文件列表
            fileMD5List: [], //文件md5列表
            flag: true, //是否是第一次进来
            link: "",
            zoneDragOver: false,
            pendingDropFiles: null,
        }
    },
    watch: {
        isDisabled(newVal, oldVal) {
            if (newVal) {
                this.isDisable = newVal
            }
        },
        xlink(newVal, oldVal) {
            if (newVal) {
                this.link = this.xlink;
            }
        },
        list: {
            handler(newVal, oldVal) {
                // console.log('newVal',newVal)
                // console.log('oldVal',oldVal)
                const listVal = Array.isArray(newVal) ? newVal : [];
                if (listVal.length > 0 && this.flag) {
                    this.flag = false
                    this.fileList = listVal.slice()
                    this.fileList.forEach(item => {
                        item.name = item.filename;
                        item.filemd5 = this.downloadURL + item.identifier;
                        this.fileMD5List.push(item.identifier)
                    });
                }
                const isEmptyList = !newVal || !Array.isArray(newVal) || newVal.length === 0;
                if (isEmptyList) {
                    const hadLocal = this.fileList.length > 0 || this.fileMD5List.length > 0 || (this.link && String(this.link).trim());
                    if (!hadLocal) {
                        this.flag = true;
                        return;
                    }
                    // 父组件每次渲染传入新的 [] 时，不应清空本地上传结果（如新增模块弹窗 :list="[]"）
                    const oldWasEmpty = !oldVal || !Array.isArray(oldVal) || oldVal.length === 0;
                    if (oldWasEmpty) {
                        return;
                    }
                    this.fileList = []
                    this.fileMD5List = []
                    this.link = ""
                    this.flag = true
                    this.handleFileChange();
                    return;
                }
                this.handleFileChange();
            },
            immediate: true,
        }
    },
    computed: {},
    methods: {
        // 关闭右侧上传抽屉提示弹窗
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        // 删除文件（zone 模式由父组件确认接口后再 removeFileAt；其它页面保持原逻辑）
        deleteFile(index) {
            const payload = {
                name: this.name,
                index,
                identifier: this.fileMD5List[index],
                fileRelId: (this.fileList[index] && this.fileList[index].fileRelId != null) ? this.fileList[index].fileRelId : null,
                fileName: (this.fileList[index] && this.fileList[index].name) || '',
            };
            if (this.zone) {
                this.$emit('fileDelete', payload);
                return;
            }
            this.removeFileAt(index);
        },
        removeFileAt(index) {
            if (index < 0 || index >= this.fileList.length) return;
            this.fileList.splice(index, 1);
            this.fileMD5List.splice(index, 1);
            this.handleFileChange();
        },
        onZoneClick() {
            if (!this.isDisable) {
                this.pendingDropFiles = null;
                this.openDrawer(true);
            }
        },
        onZoneDragOver() {
            if (this.isDisable) return;
            this.zoneDragOver = true;
        },
        onZoneDragLeave(e) {
            if (e.currentTarget && e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) {
                return;
            }
            this.zoneDragOver = false;
        },
        collectDropFiles(dataTransfer) {
            if (!dataTransfer) return [];
            const files = [];
            if (dataTransfer.items && dataTransfer.items.length) {
                for (let i = 0; i < dataTransfer.items.length; i++) {
                    const item = dataTransfer.items[i];
                    if (item.kind === 'file') {
                        const file = item.getAsFile();
                        if (file) files.push(file);
                    }
                }
            } else if (dataTransfer.files && dataTransfer.files.length) {
                Array.from(dataTransfer.files).forEach((file) => files.push(file));
            }
            return files;
        },
        onZoneDrop(e) {
            this.zoneDragOver = false;
            if (this.isDisable) return;
            const files = this.collectDropFiles(e.dataTransfer);
            if (!files.length) return;
            this.pendingDropFiles = files;
            this.openDrawer(true);
        },
        onDrawerOpened() {
            if (this.zone && this.pendingDropFiles && this.pendingDropFiles.length) {
                const files = this.pendingDropFiles;
                this.pendingDropFiles = null;
                this.$nextTick(() => {
                    const uploader = this.$refs.upload;
                    if (uploader && typeof uploader.addRawFiles === 'function') {
                        uploader.addRawFiles(files);
                    }
                });
                return;
            }
            this.openDialogAuto();
        },
        // 打开右侧上传栏
        openDrawer(flag) {
            this.isOpenDrawer = flag;
            // console.log(this.myBrowser())
            // this.upimgload = this.myBrowser() == 'Chrome' ? false : true;
        },
        // 自动打开浏览器弹窗
        openDialogAuto() {
            const input = this.$refs.upload && this.$refs.upload.$el.querySelector('input');
            if (!input) return;
            if (this.AdjustTheType === 'ReviewManagement') {
                input.setAttribute('multiple', 'multiple');
            } else {
                input.removeAttribute('multiple');
            }
            input.click();
        },
        // 文件上传成功后的回调
        closeMain(val) {
            // console.log(val);
            // this.fileMD5List.push(val.filemd5);
            // this.fileMD5List[0] = val.filemd5;
            if (this.AdjustTheType == 'ReviewManagement') {
                this.fileMD5List.push(val.filemd5);
            } else {
                this.fileMD5List[0] = val.filemd5;
            }
            // console.log(this.fileMD5List);
            let file = {
                filemd5: this.downloadURL + val.filemd5,
                name: val.name,
                fileRelId: null,
            };
            // 注释：回顾管理修改需求 允许一次上传多张图片，所以这里需要判断我是根据什么类型进行判断是否允许上传多张图片
            if (this.AdjustTheType == 'ReviewManagement') {
                this.fileList.push(file);
            } else {
                this.fileList[0] = file;
            }
            // this.fileList[0] = file;(原来)
            this.handleFileChange();
            this.$emit('fileUploaded', {
                name: this.name,
                identifier: val.filemd5,
                fileName: val.name,
            });
        },
        changeLink(val) {
            this.handleFileChange();
        },
        // 文件预览及下载
        openFile(item) {
            window.open(item.filemd5)
        },
        handleFileChange() {
            // console.log('this.fileList',this.fileList);
            // console.log('this.fileMD5List',this.fileMD5List);
            // console.log('this.link',this.link);
            // console.log('this.name',this.name);
            this.$emit('uploadFile', {
                name: this.name,
                fileList: this.fileList,
                fileMD5List: this.fileMD5List,
                link: this.link
            });
        }
    },
    activated() {
        this.isDisable = this.isDisabled;
        this.link = this.xlink;
    },
    deactivated() {
        this.fileList = []
        this.fileMD5List = []
        this.link = ""
        this.isDisable = false
        this.flag = true
    },
}
</script>

<style lang="less" scoped>
@border: #dcdfe6;
@border-light: #ebeef5;
@primary: #409eff;
@primary-light: #ecf5ff;
@text-secondary: #909399;
@text-regular: #606266;
@text-placeholder: #c0c4cc;
@danger: #f56c6c;
@bg: #f5f7fa;

.upload-file {
    /deep/ .el-button.upload {
        padding: 6px 20px;
    }

    &--zone {
        width: 100%;

        .file-list--zone {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            margin: 0 0 8px;
            padding: 0;
            list-style: none;

            li {
                display: inline-flex;
                align-items: center;
                gap: 4px;
                margin: 0;
                padding: 4px 10px;
                border-radius: 4px;
                border: 1px solid @border-light;
                background: @bg;
                color: @text-regular;
                font-size: 11px;
                line-height: 1.4;
                transition: all 0.25s ease;

                &:hover {
                    border-color: @primary;
                    color: @primary;
                    background: @primary-light;
                }

                span.name {
                    display: inline;
                    min-width: 0;
                    line-height: inherit;
                    cursor: pointer;
                }

                .delete {
                    margin-left: 4px;
                    padding: 0;
                    border: none;
                    background: none;
                    font-size: 12px;
                    line-height: 1;
                    color: @text-placeholder;
                    cursor: pointer;

                    &:hover:not(:disabled) {
                        color: @danger;
                    }

                    &:disabled {
                        cursor: not-allowed;
                        opacity: 0.5;
                    }
                }
            }
        }

        .upload-zone-trigger {
            width: 100%;
            box-sizing: border-box;
            padding: 12px 16px;
            border: 2px dashed @border;
            border-radius: 6px;
            background: transparent;
            color: @text-secondary;
            font-size: 12px;
            line-height: 1.5;
            text-align: center;
            cursor: pointer;
            transition: all 0.25s ease;
            user-select: none;

            &:hover:not(.is-disabled) {
                border-color: @primary;
                background: @primary-light;
                color: @primary;
            }

            &.is-disabled {
                cursor: not-allowed;
                opacity: 0.65;
            }

            &.drag-over:not(.is-disabled) {
                border-color: @primary;
                background: @primary-light;
                color: @primary;
            }
        }
    }


    .tips {
        margin-top: 3px;
        height: 40px;

        p.text {
            display: inline-block;
        }
    }

    .file-list {
        li {
            display: inline-block;
            line-height: 32px;

            margin: 13px 20px 5px 0;
            border-radius: 4px;
            padding: 0px 12px;

            color: #666;
            border: 1px solid rgba(204, 204, 204, .22);

            // background: rgba(204, 204, 204, 0.22);

            span.name {
                display: inline-block;
                line-height: 32px;
                min-width: 60px;
            }

            .delete {
                // background-image: url("~@/assets/images/course/closefile.png");
                display: inline-block;

                margin-left: 25px;
                width: 10px;
                height: 10px;



                background-repeat: no-repeat;
                background-size: 100% 100%;
                vertical-align: -1px;
            }
        }
    }
}
</style>